import React from 'react';
import * as PropTypes from 'prop-types';
import Button from '../Button';
import * as config from './config';
import './style.scss';

const Rules = ({ ruleName = 'default', onConfirm }) => {
  const rule = config[`${ruleName}Rules`];
  return (
    <article className="ap-rules">
      <h3>{rule.title}</h3>
      <section className="ap-rules-content">
        {
          rule.content.map((text) => {
            return <p key={text}>{text}</p>;
          })
        }
      </section>
      <Button text="知道了" onClick={onConfirm} />
    </article>
  );
};

Rules.propTypes = {
  // startDate: PropTypes.string.isRequired,
  // endDate: PropTypes.string.isRequired,
  ruleName: PropTypes.string,
  onConfirm: PropTypes.func.isRequired
};

export default Rules;
